import React, { useState } from 'react'
import { Box, Flex, Group, Button, Input, Text, Anchor, ScrollArea, Table, Paper, Image, Center, NumberFormatter } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconFileTypeXls, IconClipboardOff } from '@tabler/icons-react'
import { read, utils } from 'xlsx'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { getOrderItems } from '../../../../../store/orderItems'
import { addOrderProductItems } from '../../../../../services/orders'
import { calculation } from '../../../../../services/calculation'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'

const labelTable = [
  {
    label: 'Image',
    width: 10
  },
  {
    label: 'Product Name',
    width: 400
  },
  {
    label: 'Quantity',
    width: 'auto'
  },
  {
    label: 'Pricing',
    width: 'auto'
  },
  {
    label: 'Weigth & CBM',
    width: 'auto'
  },
  {
    label: 'Tax',
    width: 'auto'
  },
]

const FormAddProductUpload = ({ onCloseModal, onCloseModalAdd }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [dataUpload, setDataUpload] = useState([])
  const [loading, setLoading] = useState(false)

  const handleStoreProduct = async (dataProduct, indexProduct) => {
    let number = indexProduct
    const payload = {
      items: []
    }

    const handleSetVariant = (data) => {
      let dataVariant = []
      if (data.variant_optiont_1) {
        dataVariant.push({
          name: data.variant_optiont_1,
          option: data.variant_optiont_value_1,
        })
      }
      if (data.variant_optiont_2) {
        dataVariant.push({
          name: data.variant_optiont_2,
          option: data.variant_optiont_value_2,
        })
      }
      if (data.variant_optiont_3) {
        dataVariant.push({
          name: data.variant_optiont_3,
          option: data.variant_optiont_value_3,
        })
      }
      if (!data.variant_optiont_1 && !data.variant_optiont_2 && !data.variant_optiont_3) {

        dataVariant.push({
          name: 'Product Name',
          option: data.product_name,
        })
      }
      return dataVariant
    }

    const remapProduct = {
      product_id: '',
      origin_sku: dataProduct.origin_sku ? dataProduct.origin_sku : null,
      ali_sku: dataProduct.ali_sku ? dataProduct.ali_sku : null,
      supplier_id: dataProduct.supplier_id ? dataProduct.supplier_id : null,
      product_name: dataProduct.product_name,
      original_name: dataProduct.original_name,
      image_url: dataProduct.image_url,
      original_price: dataProduct.original_price,
      quantity: dataProduct.quantity,
      quantity_per_unit: 1,
      currency: dataProduct.currency,
      base_unit_name: 'pcs',
      unit_name: dataProduct.unit_name,
      price: dataProduct.original_price,
      cost: dataProduct.cost,
      weight: dataProduct.weight,
      sku_status: {
        id: 22,
      },
      rule: {
        weight_unit: 'KG',
        total_weight: 2,
        total_tax: 0,
        cbm_per_unit: dataProduct.cbm_per_unit,
        hscodes: null,
        taxes: [
          {
            label: 'BM',
            value: dataProduct.bm,
          },
          {
            label: 'PPH',
            value: dataProduct.pph,
          },
          {
            label: 'PPN',
            value: dataProduct.ppn,
          },
        ],
        weight: dataProduct.weight,
      },
      variants: handleSetVariant(dataProduct)
    }
    payload.items.push(remapProduct)
    try {
      const response = await addOrderProductItems(orderId, payload)
      if (response.success) {
        setTimeout(async () => {
          const nextPayload = number + 1
          if (nextPayload < dataUpload.length) {  
            await handleStoreProduct(dataUpload[nextPayload], nextPayload)
          } else {
            const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
            const responseCalculation = await calculation(orderId)
            if (responseCalculation.success) {
              dispatch(getOrderDetail(orderId))
              dispatch(getOrderItems(orderId))
              completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
              notificationSuccess('Upload Product to Order Completed', 'You have been added product to order')
              closeAllModal()
              setLoading(false)
            }
          }
        }, 300)
        
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubmitUploadProduct = async () => {
    setLoading(true)
    let indexProduct = 0
    handleStoreProduct(dataUpload[indexProduct], indexProduct)
  }

  

  const handleUploadFiles = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsBinaryString(fileEncoded)
    fileReader.onload = () => {
      const fileData = fileReader.result
      const wb = read(fileData, { type: 'binary' })
      const rowObject = utils.sheet_to_json(wb.Sheets.Upload)
      if (rowObject.length > 20) {
        notificationError('Upload Data Failed', 'This data record is too large. Maximum allowed is 20 records.')
      } else {
        setDataUpload(rowObject)
      }
    }
  }

  const closeAllModal = () => {
    onCloseModal()
    onCloseModalAdd()
  }

  const mappingDataTableUpload = (label, data) => {
    const mappingTableHead = (data) => data.map((val, index) => {
      return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
    })
    
    const mappingDataTable = (data) => data.map((val, index) => {
      return (
        <Table.Tr key={index}>
          <Table.Td>
            <Paper shadow="sm" w={52} withBorder radius='md' style={{ cursor: 'pointer' }}>
              <Image w={50} h={50} radius='md' src={val.image_url !== null ? val.image_url : NoImage} />
            </Paper>
          </Table.Td>
          <Table.Td>
            <Text fz={12} lineClamp={2} mb={4}>
              {val.product_name}
            </Text>
            <Text fz={10} c='dimmed' mb={2}>Origin SKU: {val.origin_sku ? val.origin_sku : '-'}</Text>
            <Text fz={10} c='dimmed'>ALI SKU: { val.ali_sku ? val.ali_sku : '-' }</Text>
          </Table.Td>
          <Table.Td>{val.quantity} {val.unit_name}</Table.Td>
          <Table.Td>
            <Text fz={12}> <NumberFormatter prefix={`${val.currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.original_price} /> (Original Price)</Text>
            <Text fz={12} c='dimmed'> <NumberFormatter prefix={`${val.currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.cost} /> (Cost)</Text>
          </Table.Td>
          <Table.Td>
            <Text fz={12}> {val.weight} {val.weight_unit}</Text>
            <Text fz={12} c='dimmed'> {val.cbm_per_unit} CBM</Text>
          </Table.Td>
          <Table.Td>
            <Text fz={12}> {val.bm} % (BM)</Text>
            <Text fz={12}> {val.ppn} % (PPN)</Text>
            <Text fz={12}> {val.pph} % (PPH)</Text>
          </Table.Td>
      </Table.Tr>
      )
    })
    return (
      <Table.ScrollContainer type='native'>
        <Table verticalSpacing="xs" highlightOnHover withTableBorder style={{ fontSize: '12px' }}>
          <Table.Thead style={{ backgroundColor: '#eeefef' }}>
            <Table.Tr>
              {mappingTableHead(label)}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody style={{ verticalAlign: 'top' }}>
            {mappingDataTable(data)}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    )
  }

  const layoutUploadFile = (dataUpload) => {
    if (dataUpload.length === 0) {
      return (
        <Center h={350}>
          <Box>
            <Input.Wrapper 
              label='Upload File Excel'
              description={<Text fz={11} c='gray.6'>Note: You can download template excel (.xlsx) file <Anchor href="https://docs.google.com/spreadsheets/d/1WTnyluDrGgkZ1_ebWgREYbmhfTVnFkvFlCdldA4QlWc/edit?usp=sharing" fz={11} target="_blank" underline="hover" c='blue'>here</Anchor> </Text>}
              size='xs'
            >
              <Box my={10}>
                <Dropzone 
                  accept={[
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  ]}
                  onDrop={(files) => handleUploadFiles(files)}
                  onReject={(files) =>console.log('onReject', files)}
                >
                  <Box ta='center' my={15}>
                    <Flex justify='center' mb={10}>
                      <IconFileTypeXls size={50} color='gray' />
                    </Flex>
                    <Box>
                      <Text fz={12} c='blue.9'>Upload File .xlsx Here</Text>
                      <Text fz={12} c='gray.6'>You can only upload files with the extension .xlxs or .xls with data max 20 record</Text>
                    </Box>
                  </Box>
                </Dropzone>
              </Box>
            </Input.Wrapper>
          </Box>
        </Center>
      )
    } else {
      return (
        <Box>
          <Text fz={13} fw='600' mb={10}>Recent File Data Upload</Text>
          <Box mb={18}>
            <ScrollArea h={350} type="auto" offsetScrollbars overscrollBehavior="none" scrollbarSize={4} scrollbars="y">
              {mappingDataTableUpload(labelTable, dataUpload)}
            </ScrollArea>
          </Box>
          <Flex justify='flex-end'>
            <Button size='xs' variant="light" leftSection={<IconClipboardOff size={14} />} onClick={() => setDataUpload([])}>Unattach Document</Button>
          </Flex>
        </Box>
      )
    }
  }
  return (
    <Box>
      <Box my={10}>
        <Box h={450}>
          {layoutUploadFile(dataUpload)}
        </Box>
      </Box>
      <Box>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={() => closeAllModal()}>Close</Button>
            <Button size='xs' variant="filled" loading={loading} onClick={() => handleSubmitUploadProduct()}>Upload</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAddProductUpload